
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contacto",
      function () {
        return require("private-next-pages/contacto.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contacto"])
      });
    }
  